import {Component, OnInit, EventEmitter, Input, Output, DoCheck} from '@angular/core';
import {PagingModel} from './PagingModel';
import {UtilService} from '../../services/UtilService';

@Component({
  selector: 'app-pagination-control',
  templateUrl: './pagination-control.component.html',
  styleUrls: ['./pagination-control.component.scss']
})
export class PaginationControlComponent implements OnInit, DoCheck {
  @Input() input: PagingModel = new PagingModel();
  @Input() showAll = false;
  @Output() pageChanged: EventEmitter<PagingModel> = new EventEmitter();
  utilService: UtilService;

  constructor(private utilsService: UtilService) {
    this.utilService = utilsService;
  }

  private static setText(selector: string, text: string): void {
    const elements = document.getElementsByClassName(selector);
    // @ts-ignore
    for ( const element of elements){
      element.innerHTML = text;
    }
  }

  ngOnInit(): void {
    if (!this.input) {
      this.input = new PagingModel();
    }
    if (this.showAll){
      this.input.pageSizes.push('All');
    }
  }

  ngDoCheck(): void {
    this.populateSpecificPageButtons();
  }

  populateSpecificPageButtons(): void {
    this.input.specificPageButtons = [];
    this.input.specificPageButtons.push(1);

    if (this.input.totalRows) {
      if (this.input.totalPages > 3) {
        if (this.input.totalPages === 4) {
          this.input.specificPageButtons.push(2);
          this.input.specificPageButtons.push(3);
          this.input.specificPageButtons.push(4);
        } else if (this.input.page === 0 || this.input.page - 1 === 0 || this.input.page - 2 === 0) {
          this.input.specificPageButtons.push(2);
          this.input.specificPageButtons.push(3);
          this.input.specificPageButtons.push('...');
          this.input.specificPageButtons.push(this.input.totalPages);
        } else if (this.input.page + 1 === this.input.totalPages
          || this.input.page + 2 === this.input.totalPages
          || this.input.page + 3 === this.input.totalPages) {
          this.input.specificPageButtons.push('...');
          this.input.specificPageButtons.push(this.input.totalPages - 2);
          this.input.specificPageButtons.push(this.input.totalPages - 1);
          this.input.specificPageButtons.push(this.input.totalPages);
        } else if (this.input.totalPages > 6 && this.input.page - 2 > 0 && this.input.page + 2 < this.input.totalPages) {
          this.input.specificPageButtons.push('...');
          this.input.specificPageButtons.push(this.input.page);
          this.input.specificPageButtons.push(this.input.page + 1);
          this.input.specificPageButtons.push(this.input.page + 2);
          this.input.specificPageButtons.push('...');
          this.input.specificPageButtons.push(this.input.totalPages);
        }
      } else {
        for (let index = 1; index < this.input.totalPages; index++) {
          this.input.specificPageButtons.push(index + 1);
        }
      }
    } else {
      if (this.input.page < 3) {
        for (let index = 1; index <= this.input.page; index++) {
          this.input.specificPageButtons.push(index + 1);
        }
      } else {
        this.input.specificPageButtons.push('...');
        this.input.specificPageButtons.push(this.input.page);
        this.input.specificPageButtons.push(this.input.page + 1);
      }

      if (this.input.pageSize === this.input.visibleRows) {
        this.input.specificPageButtons.push(this.input.page + 2);
      }
    }

    const startRecord = this.input.page * this.input.pageSize + 1;
    let endRecord = (this.input.page + 1) * this.input.pageSize;
    endRecord = this.input.totalRows && endRecord > this.input.totalRows ? this.input.totalRows : endRecord;
    PaginationControlComponent.setText('lbCurrentPageRange',
      this.utilsService.formatNumber(startRecord) + '-' + this.utilsService.formatNumber(endRecord));
  }

  onBtFirst(): void {
    if (!this.isFirstPage()) {
      this.input.page = 0;
      this.onPageChanged();
    }
  }

  onBtLast(): void {
    if (!this.isLastPage()) {
      this.input.page = this.input.totalPages - 1;
      this.onPageChanged();
    }
  }

  onBtNext(): void {
    if (!this.isLastPage()) {
      this.input.page += 1;
      this.onPageChanged();
    }
  }

  onBtPrevious(): void {
    if (!this.isFirstPage()) {
      this.input.page -= 1;
      this.onPageChanged();
    }
  }

  goToPage(param: number): void {
    if (this.input.page !== param - 1) {
      this.input.page = param - 1;
      this.onPageChanged();
    }
  }

  onPageSizeChanged(): void {
    const elem = document.getElementsByClassName('page-size') as HTMLSelectElement;
    const dropdown0 = (elem[0] as unknown as HTMLSelectElement).value;
    // const dropdown1 = (elem[1] as unknown as HTMLSelectElement).value;
    const value = this.input.pageSize === Number(dropdown0) ? 0 : dropdown0;
    this.input.page = 0;
    this.input.pageSize = Number(value);
    this.onPageChanged();
  }

  onPageChanged(): void {
    this.populateSpecificPageButtons();
    this.pageChanged.emit();
  }

  isFirstPage(): boolean {
    return this.input.page === 0;
  }

  isLastPage(): boolean {
    let result: boolean;

    if (this.input.totalPages) {
      result = this.input.page + 1 === this.input.totalPages;
    } else {
      result = this.input.visibleRows < this.input.pageSize;
    }

    return result;
  }
}
